
import axios from 'axios';
import moment from 'moment';

import { ItemAdapter } from './Item';

axios.defaults.baseURL = `${process.env.VUE_APP_API_HOST}/api`;

export async function getItem(id) {
  const response = await axios.get(`/items/${id}`);
  return await adaptItems([response.data]);
}

export async function getAllItems() {
  const response = await axios.get(`/items`);
  return await adaptItems(response.data);
}

export function adaptItems(items) {
  return Promise.all(items.map(async (item) => {
    const inflatedItem = ItemAdapter.inflate(item)
    const response = await axios.get(`/item-history-entries?itemId=${item.id}`);
    inflatedItem.history = response.data.map((historyEntry) => {
      const unixTimestamp = moment(historyEntry.entryCreated).valueOf();
      historyEntry.date = unixTimestamp;
      return historyEntry;
    });
    return inflatedItem;
  }));
}

export async function getNewItems() {
  // TODO: sort by `sortIndex`
  const response = await axios.get(`/items?studying=false&placeholder=false`);
  return await adaptItems(response.data);
}

export async function putItem(item) {
  const flattenedItem = ItemAdapter.flatten(item);
  return await axios.put(`/items`, flattenedItem);
}

export async function postItem(item) {
  const flattenedItem = ItemAdapter.flatten(item);
  return await axios.post(`/items`, flattenedItem)
}

export async function deleteItem(itemId) {
  const response = await axios.delete(`/items/${itemId}`);
  return response.data;
}

export async function isWordMarkedAsKnown(word) {
  const response = await axios.get(`/items?thai=${word.text}&placeholder=true`);
  return await response.data.length >= 1;
}

function saveItemToDb(item) {
  const flattenedItem = ItemAdapter.flatten(item);

  return axios.post(`/items`, flattenedItem)
  .then(() => {
    item.history = item.history || [];
    const promises = item.history.map((historyEntry) => {
      return axios.post(`/item-history-entries`, {
        itemId: item.id,
        score: historyEntry.score,
        entryCreated: new Date(historyEntry.date),
      })
      .then(() => {
        console.log('submitted history item!');
      })
      .catch((error) => {
        console.log("couldn't log history entry");
      });
    });

    return Promise.all(promises);
  });
}
